import React from "react";
import { useTranslation } from "react-i18next";

import { InfoPlate } from "fe-shared/src/components";
import { RequestStatusBadge } from "fe-shared-requests/src/components";
import { formatRequestNumber } from "fe-shared-requests/src/helpers/format";
import { PickupRequestStatus } from "fe-shared-requests/src/types";

import PickupRequestAssigneeSelect from "components/PickupRequestAssigneeSelect";

import styles from "./PickupRequestStatusHeader.module.scss";

interface Props {
  canAssign: boolean;
  requestNumber: string;
  status: PickupRequestStatus;
  assignedTo: number | null;
  assignedToFullName: string | null;
}

const PickupRequestStatusHeader = (props: Props) => {
  const {
    canAssign,
    requestNumber,
    status,
    assignedTo,
    assignedToFullName,
  } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <InfoPlate variant="black">
        {formatRequestNumber(requestNumber)}
      </InfoPlate>
      <RequestStatusBadge status={status} className={styles.status} />
      <div className={styles.assign}>
        {!!assignedTo && (
          <span className={styles.assignLabel}>
            {t("pickupRequests.grid.cols.assignedTo")}
          </span>
        )}
        <PickupRequestAssigneeSelect
          canAssign={canAssign}
          requestNumber={requestNumber}
          status={status}
          assigneeId={assignedTo ?? undefined}
          assigneeName={assignedToFullName ?? undefined}
        />
      </div>
    </div>
  );
};

export default PickupRequestStatusHeader;
